class VariantDropdownRich extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('.variant-dropdown-rich__select');
    this.trigger = this.querySelector('.variant-dropdown-rich__trigger');
    this.triggerContent = this.querySelector('[data-variant-dropdown-trigger]');
    this.list = this.querySelector('.variant-dropdown-rich__list');
    this.optionButtons = this.querySelectorAll('.variant-dropdown-rich__option-button');

    if (!this.select || !this.trigger || !this.list) return;

    this.onTriggerClick = this.toggleList.bind(this);
    this.onOptionClick = this.handleOptionClick.bind(this);
    this.onSelectChange = this.syncFromSelect.bind(this);
    this.onDocumentClick = this.handleDocumentClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);

    this.trigger.addEventListener('click', this.onTriggerClick);
    this.select.addEventListener('change', this.onSelectChange);
    this.optionButtons.forEach((button) => {
      button.addEventListener('click', this.onOptionClick);
    });
    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('keydown', this.onKeydown);
    this.syncFromSelect();
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTriggerClick);
    this.select?.removeEventListener('change', this.onSelectChange);
    this.optionButtons?.forEach((button) => {
      button.removeEventListener('click', this.onOptionClick);
    });
    document.removeEventListener('click', this.onDocumentClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  toggleList(event) {
    event.preventDefault();
    event.stopPropagation();
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.closeList();
    } else {
      this.openList();
    }
  }

  openList() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.list.hidden = false;
    this.classList.add('is-open');
  }

  closeList() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.list.hidden = true;
    this.classList.remove('is-open');
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeList();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.closeList();
      this.trigger.focus();
    }
  }

  handleOptionClick(event) {
    const button = event.currentTarget;
    if (button.disabled) return;

    const value = button.dataset.value;
    if (!value || this.select.value === value) {
      this.closeList();
      return;
    }

    this.select.value = value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
    this.closeList();
  }

  syncFromSelect() {
    const option = this.select.selectedOptions[0];
    if (!option || !this.triggerContent) return;

    this.triggerContent.innerHTML = this.buildTriggerHtml(option);

    this.querySelectorAll('.variant-dropdown-rich__option').forEach((item) => {
      const button = item.querySelector('.variant-dropdown-rich__option-button');
      const isSelected = button?.dataset.value === this.select.value;
      item.classList.toggle('is-selected', isSelected);
      button?.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    const labelValue = this.closest('.product-form__input')?.querySelector('[data-selected-value]');
    if (labelValue) {
      labelValue.textContent = option.value;
    }
  }

  buildTriggerHtml(option) {
    const title = this.escapeHtml(option.value);
    const sku = this.escapeHtml(option.dataset.sku || '');
    const price = this.escapeHtml(option.dataset.price || '');
    const comparePrice = this.escapeHtml(option.dataset.comparePrice || '');
    const imageUrl = option.dataset.imageUrl || '';

    const imageHtml = imageUrl
      ? `<img src="${this.escapeHtml(imageUrl)}" alt="" class="variant-dropdown-rich__img" loading="lazy" width="46" height="46">`
      : '<span class="variant-dropdown-rich__img-placeholder"></span>';

    const skuHtml = sku
      ? `<span class="variant-dropdown-rich__sku">${sku}</span>`
      : '';

    const compareHtml = comparePrice
      ? `<span class="variant-dropdown-rich__price-compare">${comparePrice}</span>`
      : '';

    return `
      <span class="variant-dropdown-rich__thumb" aria-hidden="true">${imageHtml}</span>
      <span class="variant-dropdown-rich__info">
        <span class="variant-dropdown-rich__title">${title}</span>
        ${skuHtml}
      </span>
      <span class="variant-dropdown-rich__price">
        ${compareHtml}
        <span class="variant-dropdown-rich__price-current">${price}</span>
      </span>
    `;
  }

  escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

if (!customElements.get('variant-dropdown-rich')) {
  customElements.define('variant-dropdown-rich', VariantDropdownRich);
}
